import { styled } from "styled-components";

export const SidebarSection = styled.div`
    width: 300px;
    padding: 30px ;
    position: fixed;
    left: 0;
    top: 100px;

    p {
        font-weight: 600;
        font-size: 18px;
        text-align: center;
    }

    @media (max-width: 768px) {
        width: 0;
    }
`